const getDistanceInUnit = (distance, distanceUnit) => {
    if (distanceUnit === 'km') {
        return (distance / 1000).toFixed(2);
    }
    return (distance * 0.000621371).toFixed(2);
};

export default getDistanceInUnit;
